import { memo } from 'react';
import NoDataPlaceholder from 'components/DiscoverPage/NoDataPlaceholder';
import LazyCardGrid from 'components/LazyCardGrid';
import classNames from 'styles/utils/classNames';
import ClinicCard from './ClinicCard';
import ClinicCardSkeleton from './ClinicCardSkeleton';
import { UPCOMING_GROUP_LESSON_LOAD_COUNT } from '../constants';
import { ClinicSectionProps } from '../types';

const MemoisedClinicCard = memo(ClinicCard);

interface ClinicDisplayProps extends ClinicSectionProps {
  showBackground?: boolean;
  showTitle?: boolean;
}

const ClinicDisplay: React.FC<ClinicDisplayProps> = ({
  coachUpcomingClinicLessonsData,
  loading,
  handleGetUpcomingLessonsById,
  showBackground = true,
  showTitle = true,
}) => {
  const total = coachUpcomingClinicLessonsData?.lessonsAggregate.aggregate?.count || 0;
  const loadedLessons = coachUpcomingClinicLessonsData?.lessons || [];

  return (
    <div
      className={classNames(
        showBackground &&
          'rounded-xl bg-color-bg-lightmode-tertiary px-ds-2xl py-ds-xl dark:bg-color-bg-darkmode-tertiary max-sm:px-ds-lg',
        !loading && total === 0 && showBackground && 'bg-transparent !px-0',
      )}
    >
      {showTitle && (
        <h2 className="typography-product-heading-compact-desktop mb-ds-xl">
          Upcoming group lessons
        </h2>
      )}

      {!loading && total === 0 && <NoDataPlaceholder text="No Upcoming Lessons" />}

      <LazyCardGrid
        uniqueKey="id"
        loadMoreButtonProps={{
          title: 'View more lessons',
          variant: 'secondary',
          size: 'md',
          className: 'w-fit bg-transparent max-sm:border-0',
        }}
        gap="1rem"
        totalAvailable={total}
        onLoadMore={handleGetUpcomingLessonsById}
        skeletonCard={<ClinicCardSkeleton />}
        loading={loading}
        cards={loadedLessons}
        renderCard={(card) => <MemoisedClinicCard groupLesson={card} key={card.id} />}
        cardsInRow={{
          base: 1,
        }}
        loadCount={UPCOMING_GROUP_LESSON_LOAD_COUNT}
      />
    </div>
  );
};

export default ClinicDisplay;
